var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonFine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -837.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Fine",
    transform: "translate(1206.000000, 837.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,20.7222222 C9.791,20.7222222 8,18.8317222 8,16.5 C8,14.1682778 9.791,12.2777778 12,12.2777778 C14.209,12.2777778 16,14.1682778 16,16.5 C16,18.8317222 14.209,20.7222222 12,20.7222222 L12,20.7222222 Z M19,7 L19,10.1666667 L16,10.1666667 L16,7 L12,7 C7.718,7 4.141,10.1592778 3.23,14.3888889 L2,14.3888889 C0.896,14.3888889 0,15.3346667 0,16.5 C0,17.6653333 0.896,18.6111111 2,18.6111111 L3.23,18.6111111 C4.141,22.8407222 7.718,26 12,26 C16.971,26 21,21.7471667 21,16.5 L32,13.3333333 L32,7 L19,7 Z",
    id: 221
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonFine);
export default __webpack_public_path__ + "static/media/common-fine.c0fd489e.svg";
export { ForwardRef as ReactComponent };